import {useTimeout} from "@hosttools/frontend";
import {ButtonIconTooltip} from "@hosttools/frontend/components";
import {CheckIcon, CopyIcon} from "@hosttools/frontend/react/components/Icons";
import type {FC} from "react";
import {memo, useCallback, useState} from "react";

import useCopyToClipboard from "@/client/hooks/useCopyToClipboard";

interface Props {
    value: string;
    onCopy?: () => void;
}

const CopyText: FC<Props> = ({value, onCopy}) => {
    const [copied, setCopied] = useState(false);
    const [, copy] = useCopyToClipboard();
    const cleanup = useTimeout(() => setCopied(false), 2_000);

    const handleCopy = useCallback(() => {
        setCopied(true);
        copy(value);
        onCopy?.();
        cleanup();
    }, [value, copy, cleanup, onCopy]);

    return (
        <ButtonIconTooltip
            action={copied ? "primary" : "default"}
            icon={copied ? CheckIcon : CopyIcon}
            size="sm"
            tooltip={copied ? "Copied" : "Copy"}
            onPress={handleCopy}
        />
    );
};

export default memo(CopyText);
